import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://6f33c1a6cbfb9ba7c29ea69b176948b6@o4507088806543360.ingest.us.sentry.io/4511623431389184',
  environment: window.sentryEnvironment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration()
  ],
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,
})
